import React, { Component } from 'react';

import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

import RadioButtonPermisos from './RadioButtonPermisos.jsx';
import BusquedaGrupoWindows from './BusquedaGrupoWindows.jsx';

class NuevoPerfil extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: "",
            productId: 0,
            profileId: 0,
            typeCopy: 0,
            showResults: false,
            descripcion: ""
        }

        this.onChangeRadio = this.onChangeRadio.bind(this);
    }

    handleChange = (e) => {
        this.setState({ value: e.target.value });
    }

    handleChangeDescripcion = (e) => {
        this.setState({ descripcion: e.target.value });
    }

    onChangeProduct = (e) => {
        this.setState({ productId: e.target.value });
    }

    addGroupWindows(event) {
        let value = event.target.dataset.value;
        let checked = event.target.checked;

        if (checked) {
            this.props.addGroupWindows(parseInt(value));
        } else {
            this.props.deleteGroupWindows(parseInt(value));
        }
    }

    onChangeProfile = (e) => {
        let IdProfile = e.target.value;
        let showResults = false;
        let typeCopy = 0;

        if (IdProfile != 0) {
            showResults = true;
            typeCopy = 1;
        }

        this.setState({ profileId: IdProfile, typeCopy: typeCopy, showResults: showResults });
    }

    onChangeRadio(id) {
        this.setState({ typeCopy: id });
    }

    getDataModal = () => {
        this.props.nuevoPerfil(this.state.value, this.state.productId, this.state.profileId, this.state.typeCopy, this.state.descripcion);
    }

    clean = () => {
        this.setState({
            showResults: false,
            productId: 0,
            profileId: 0,
            typeCopy: 0,
            value: "",
            descripcion: ""
        });

        this.props.gruposWindows.forEach( (group) => {
            this.props.deleteGroupWindows(group.Id);
        });

        this.props.stopClear();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.data.clearFlag)
            this.clean();
    }

    render() {
        const { props } = this;

        let selected;

        if(props.data.clearFlag){
            this.clean();
        }  
        
        let profiles = JSON.parse(JSON.stringify(props.data.perfiles));
        profiles.unshift({ Id: 0, Codigo: "Ninguno" });

        let oPerfil = profiles.map(function (profile) {
            selected = profile.Id == 0 ? true : false;
            return <GenericOption selected={selected} id={profile.Id} description={profile.Codigo} key={"NewProfile_" + profile.Id} />
        });
                                             
        let products = JSON.parse(JSON.stringify(props.data.productos));
        products.shift();
        products.unshift({ Id: 0, Descripcion: "Todos" });

        let oProducto = products.map(function (product) {
            selected = product.Id == 0 ? true : false;
            return <GenericOption selected={selected} id={product.Id} description={product.Descripcion} key={"NewProduct_" + product.Id} />
        });

        let saveErrorMessage = props.data.saveErrorMessage;
        let saveDescripcionErrorMessage = props.data.saveDescripcionErrorMessage;

        let gruposWindows = [];
        let oGruposWindows;
        let gruposWindowsSeleccionados = [];

        if (props.gruposWindows != undefined) {
            gruposWindows = JSON.parse(JSON.stringify(props.gruposWindows));

            gruposWindows.forEach(function (grupo) {
                if (grupo.Selected)
                    gruposWindowsSeleccionados.push(grupo);
            })
        }        
        
        return (
            <div className="modal fade-out" id="newProfileModal" role="dialog" data-backdrop="static">
                <div className="modal-dialog modal-profile modal-generic">
                    <div className="modal-content">
                        <div className="modal-header" data-label="Título">
                            <div className="close" data-dismiss="modal" aria-hidden="true">
                                <label className="ti-close clickable" onClick={props.startClear}></label>
                            </div>
                            <h2 className="modal-title">Nuevo Perfil</h2>
                        </div>
                        <div className="modal-body modal-perfiles-body">
                            <div className="form-group bottom-separator-xs" data-label="Campo nombre del perfil (nuevo)">
                                <label className="label-primary">Nombre del perfil</label>
                                <input id="nombre_perfil" className="form-control default-input" type="text" value={this.state.value}
                                    placeholder="Nombre del perfil"
                                    onChange={this.handleChange} maxLength="50" autoComplete="off" />
                                {saveErrorMessage &&
                                    <label className="error zmdi-alert-circle">
                                        {saveErrorMessage}
                                    </label>}
                            </div>

                            <div className="form-group bottom-separator-xs" data-label="Descripción">
                                <label className="label-primary">Descripción</label>
                                <input id="descripcion_perfil" className="form-control default-input" type="text" value={this.state.descripcion}
                                    placeholder="Descripción del perfil"
                                    onChange={this.handleChangeDescripcion} maxLength="50" autoComplete="off" />
                                {saveDescripcionErrorMessage &&
                                    <label className="error zmdi-alert-circle">
                                        {saveDescripcionErrorMessage}
                                    </label>}
                            </div>

                            {!props.data.clearFlag &&
                                <div className="form-group bottom-separator-xs">
                                    <label className="label-primary">Asociar con sistema</label>
                                    <GenericSelect id="selProductos" options={oProducto} onChange={this.onChangeProduct}
                                        className="form-control default-select" />
                                </div>
                            }

                            {/*/
                            {!props.data.clearFlag &&
                                <div className="form-group bottom-separator-xs" data-label="Copiar los permisos que el perfil">
                                    <label className="label-primary">Copiar los permisos que el perfil</label>
                                    <GenericSelect id="selPerfiles" options={oPerfil} onChange={this.onChangeProfile}
                                        className="form-control default-select" />
                                </div>
                            }

                            {this.state.showResults &&
                                <RadioButtonPermisos data={props.data} onChangeRadio={this.onChangeRadio} />}

                            */}       

                            {(props.configuracionSesion.TipoSeguridad == 'AD'
                                && gruposWindows) &&
                                <BusquedaGrupoWindows gruposWindows={gruposWindows}
                                    gruposWindowsSeleccionados={gruposWindowsSeleccionados}
                                    addGroupWindows={props.addGroupWindows}
                                    deleteGroupWindows={props.deleteGroupWindows} />
                            }
                        </div>

                        <div className="modal-footer">
                            <div className="row">
                                <div className="col-xs-5">
                                    <button type="button" className="btn btn-primary btn-cta"
                                        onClick={this.getDataModal}>Guardar</button>
                                </div>
                                <div className="col-xs-7">
                                    <button type="button" className="btn btn-default btn-secondary" data-dismiss="modal"
                                        onClick={props.startClear} >Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NuevoPerfil;